import { useMemo, useState } from 'react';
import { useApiCall } from 'use-api-call';
import lendingSvc from '../api/lendingService';
import {
  LendingService,
  LendingServiceRequest,
  SearchLendingServiceRequest,
  UseApiCallProps,
} from '../types';
import ACTIONS from '../types/actionsEnum.type';

const useActions = () => {
  const [userAction, setUserAction] = useState<ACTIONS | undefined>(undefined);
  const {
    data: lendingsData,
    invoke: getLendings,
    loading: loadingLendings,
    error: errorLendings,
  }: UseApiCallProps<LendingService, LendingServiceRequest> = useApiCall(
    (values: LendingServiceRequest) => lendingSvc.getLendings(values)
  );

  const {
    data: searchLendingsData,
    invoke: searchLendings,
    loading: loadingSearchLendings,
    error: errorSearchLendings,
  }: UseApiCallProps<LendingService, SearchLendingServiceRequest> = useApiCall(
    (values: SearchLendingServiceRequest) => lendingSvc.searchLendings(values)
  );

  const getLendingsService = (enterpriseId: string) =>
    getLendings({ enterpriseId });

  const searchLendingsService = (values: SearchLendingServiceRequest) =>
    searchLendings(values);

  const loading = useMemo(
    () => loadingLendings || loadingSearchLendings,
    [loadingLendings, loadingSearchLendings]
  );
  const error = useMemo(
    () => errorLendings || errorSearchLendings,
    [errorLendings, errorSearchLendings]
  );
  const data = useMemo(
    () => searchLendingsData || lendingsData,
    [searchLendingsData, lendingsData]
  );

  return {
    data,
    loading,
    error,
    userAction,
    getLendingsService,
    searchLendingsService,
    setUserAction,
  };
};

export default useActions;
